<template>
  <div style="padding: 10px">
    <el-form :model="busData" inline label-width="130px" >

      <el-form-item label="报价编号：" required>
        <el-input v-model="busData.quote_no" class="form-item" />
      </el-form-item>

      <el-form-item label="选择报价模板：" >
        <el-select v-model="busData.quoteTemplateId" class="form-item" placeholder="选择报价模板" clearable>
          <el-option v-for="item in quoteTemplateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择联系人：" v-if="busData.finalVersion==false && busData.fileGenerateType=='system_generate'">
        <el-select v-model="busData.contactId" class="form-item" placeholder="选择联系人" clearable="true" filterable="true">
          <el-option v-for="item in contactList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="报价单内容加载：">
        <el-select v-model="busData.quoteId" class="form-item" placeholder="选择报价单" clearable>
          <el-option v-for="item in quoteList" :key="item.id" :label="getQuoteLabel(item)" :value="item.id"></el-option>
        </el-select>
        <el-button style="margin-left: 20px" @click="loadQuoteItems()">加载内容</el-button>
        <el-button style="margin-left: 20px" @click="addItemRow(1)">添加商品行</el-button>
      </el-form-item>
    </el-form>

    <el-row class="box">
      <el-col :span="7">商品名称</el-col>
      <el-col :span="3">授权方式</el-col>
      <el-col :span="2">市场价</el-col>
      <el-col :span="1">税率%</el-col>
      <el-col :span="2">销售价</el-col>
      <el-col :span="2">折扣</el-col>
      <el-col :span="2">数量</el-col>
      <el-col :span="5">备注</el-col>
    </el-row>

    <div style="height: 482px;overflow-x: hidden;overflow-y: auto">
      <el-row v-for="item in busData.itemList" :key="item.product_ids" class="row" :gutter="25">
        <el-col :span="7">
          <el-cascader v-model="item.product_ids" :options="catalogWithProducts" style="width: 100%"
                       :show-all-levels="false" placeholder="选择商品"
                       :props="props" clearable filterable @change="onProductSelect(item)"/>
        </el-col>
        <el-col :span="3" class="tip">
          <el-select v-model="item.authorize_type" class="form-item" placeholder="授权方式" clearable="true" @change="onPriceSelect(item)">
            <el-option v-for="price in item.price_list" :key="price.id" :label="price.authorize_type_name" :value="price.authorize_type"></el-option>
          </el-select>
        </el-col>
        <el-col :span="2" class="tip">{{ item.market_price }}</el-col>
        <el-col :span="1" class="tip">{{ item.tax_rate }}</el-col>
        <el-col :span="2">
          <el-input v-model="item.sales_price" @change="changeSalesPrice(item)" placeholder="销售价" style="width: 100%"></el-input>
        </el-col>
        <el-col :span="2">
          <el-input v-model="item.discount_ratio" @change="changeDiscountRatio(item)" placeholder="折扣比例" style="width: 100%"></el-input>
        </el-col>
        <el-col :span="2">
          <el-input-number v-model="item.cnt" @change="calcTotalPrice()" :min="0" :max="200" placeholder="数量" style="width: 120px"></el-input-number>
        </el-col>
        <el-col :span="5">
          <el-input v-model="item.remark" class="w-percent-90" placeholder="备注"></el-input>
          <div class="close" @click="removeItemRow(item.nanoid)">
            <el-icon>
              <ElIconClose></ElIconClose>
            </el-icon>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-row style="margin-top: 15px">
      <el-col :span="9">
        <el-input type="textarea" class="quote-remark" v-model="busData.remark" placeholder="报价备注" style="width: 100%"
                  :autosize="true"></el-input>
      </el-col>
      <el-col :span="4" :offset="6" class="tax-amount">
        <span>税额：{{ this.busData.taxAmountFormat }}</span>
      </el-col>
      <el-col :span="3" class="tax-amount">
        <span>总金额：{{ this.busData.totalAmountFormat }}</span>
      </el-col>
    </el-row>

    <el-form-item>
      <el-button type="primary" style="width: 500px;;margin-top: 20px" @click="addQuote" :loading="loading">提交</el-button>
    </el-form-item>
  </div>
</template>

<script>
import {nanoid} from 'nanoid'
export default {
  name: "ChanceQuote",
  i18n: {},
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      props: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'name'
      },
      priceTips: false,
      busData: {
        finalVersion: false,
        fileGenerateType: 'system_generate',
        uploadFileIds: [],
        taxAmount: 0,
        totalAmount: 0,
        taxAmountFormat: 0,
        totalAmountFormat: 0,
        quoteId: '',
        chanceId: '',
        remark: '',
        itemList: [],
        quoteTemplateId: ''
      },
      quoteList: [],
      productAll: [],
      catalogWithProducts: [],
      contactList: [],
      quoteTemplateList: [],
      loading: false
    }
  },
  computed: {},
  created() {
    this.addItemRow(10)
    this.getCompanyContactList()
    this.getCatalogWithProducts()
    this.getQuoteTemplateList()
    this.getQuoteList()
  },
  methods: {
    async getCatalogWithProducts() {
      this.catalogWithProducts = await this.$http('crmProductCatalogService.getCatalogWithProducts')
      //从目录树里面获取所有产品，不要再从后端读一次
      this.productAll = []
      this.readProducts(this.catalogWithProducts)
    },
    readProducts(catalogList) {
      if (!catalogList || catalogList.length == 0) {
        return;
      }

      for (var i = 0; i < catalogList.length; i++) {
        var busObject = catalogList[i]
        if (busObject.is_product == true) {
          this.productAll.push(busObject);
        } else {
          this.readProducts(busObject.children)
        }
      }
    },
    getProductById(productId) {
      for (var i = 0; i < this.productAll.length; i++) {
        if (this.productAll[i].id == productId) {
          return this.productAll[i];
        }
      }
      return null;
    },
    reset() {
      this.clearPreData()
      this.$refs.commitMessage.clear()

    },

    clearPreData() {
      //清空表单数据
      this.busData.result = ''
      this.busData.remark = ''
      this.busData.itemList = []
      this.addItemRow(10);
      this.calcTotalPrice();
    },
    //获取联系人
    async getCompanyContactList() {
      let params = {chance_id:this.parentData.chance_id}
      this.contactList = await this.$http('crmChanceService.getCompanyContact', params)
    },
    //获取报价列表
    async getQuoteList() {
      let params = {chance_id:this.parentData.chance_id}
      this.quoteList = await this.$http('crmQuoteService.getChanceQuotes', params)
    },
    //获取报价明细
    async loadQuoteItems() {
      if (this.busData.quoteId == '') {
        return;
      }

      let params = {quote_id:this.busData.quoteId}
      let quoteData = await this.$http('crmQuoteService.getQuoteWithDetail', params)
      this.busData.itemList = quoteData.item_list || [];
      this.calcTotalPrice();
    },
    getQuoteLabel(item) {
      var amountFormat = this.formatMoney(item.total_amount);
      return item.quote_no + ' (' + amountFormat + ")";
    },
    changeSalesPrice(item) {
      if (!item.product_id) {
        this.$message.error("请先选择商品");
        return;
      }

      if (item.market_price == 0) {
        item.discount_ratio = 0
        return;
      }

      item.discount_ratio = parseInt(item.sales_price * 100 / item.market_price);
      this.calcTotalPrice();
    },
    changeDiscountRatio(item) {
      if (!item.product_id) {
        this.$message.error("请先选择商品");
        return;
      }

      if (item.market_price == 0) {
        item.sales_price = 0
        return;
      }

      item.sales_price = parseInt(item.market_price * item.discount_ratio / 100);
      this.calcTotalPrice();
    },
    //获取商品详情
    onProductSelect(item) {
      console.log("item.product_ids:")
      console.log(item.product_ids)
      if (!item.product_ids || item.product_ids.length == 0) {
        item.unit = "";
        item.market_price = 0;
        item.tax_rate = 0;
        item.sales_price = 0;
        item.discount_ratio = 0;
        item.cnt = 0;
        this.calcTotalPrice();
        return
      }

      var productId = item.product_ids[item.product_ids.length - 1]
      console.log("productId=" + productId)

      var product = this.getProductById(productId);
      if (!product) {
        return this.$message.error("未找到商品,id:" + productId);
      }

      item.product_id = product.id;
      item.unit = product.unit;
      item.price_list = product.price_list;
      item.current_price = {};

      this.calcTotalPrice();
    },
    onPriceSelect(item){
      if (!item.authorize_type || item.authorize_type.length == 0) {
        item.unit = "";
        item.market_price = 0;
        item.tax_rate = 0;
        item.sales_price = 0;
        item.discount_ratio = 0;
        item.cnt = 0;
        this.calcTotalPrice();
        return
      }

      for (var i = 0; i < item.price_list.length; i++) {
        var priceTmp = item.price_list[i]

        if (priceTmp.authorize_type == item.authorize_type) {
          item.market_price = priceTmp.price;
          item.tax_rate = priceTmp.tax_rate;
          break;
        }
      }
      this.calcTotalPrice();
    },
    //计算总价
    calcTotalPrice() {
      this.busData.totalAmount = 0;
      this.busData.taxAmount = 0;

      for (var i = 0; i < this.busData.itemList.length; i++) {
        var item = this.busData.itemList[i]

        if (item.product_id && item.sales_price && item.cnt) {
          var itemAmount = item.sales_price * item.cnt
          this.busData.totalAmount += itemAmount;
          this.busData.taxAmount += itemAmount * item.tax_rate / (100 + item.tax_rate);
        }
      }

      this.busData.taxAmountFormat = this.formatMoney(this.busData.taxAmount)
      this.busData.totalAmountFormat = this.formatMoney(this.busData.totalAmount)
    },
    //将数字转换成金额显示
    formatMoney(num) {
      num = num.toFixed(2);
      num = parseFloat(num)
      num = num.toLocaleString();
      return num;//返回的是字符串23,245.12保留2位小数
    },
    async getQuoteTemplateList() {
      this.quoteTemplateList = await this.$http('crmDsService.getQuoteTemplates')
    },
    addQuote() {

      if (this.busData.quote_no == '') {
        return this.$message.error("报价编号未输入");
      }

      var cnt = 0;
      for (let i = 0; i < this.busData.itemList.length; i++) {
        let obj = this.busData.itemList[i]
        if (obj.product_id) {

          if (!obj.market_price) {
            return this.$message.error(`第${i + 1}行标准价不能为空`);
          }

          if (!obj.tax_rate) {
            return this.$message.error(`第${i + 1}行税率不能为空`);
          }

          if (!obj.sales_price) {
            return this.$message.error(`第${i + 1}行销售价不能为空`);
          }

          if (!obj.cnt) {
            return this.$message.error(`第${i + 1}行数量不能为空`);
          }

          cnt++;
          obj.has_data = true;
        }
      }

      if (cnt == 0) {
        return this.$message.error("报价数据不能为空");
      }

      this.busData.chanceId = this.parentData.chance_id;
      this.loading = true;

      this.$http('crmQuoteService.makeQuote', this.busData).then(data => {
        this.loading = false;
        this.clearPreData();
        this.$fn.closeWindow();
        this.$fn.search();
        this.$message.success("提交成功");
      })
    },
    addItemRow(cnt) {
      for(var i=0;i<cnt;i++){
        this.busData.itemList.push({
          nanoid: nanoid(),
          productDetails: {}
        })
      }
    },
    removeItemRow(nanoid) {
      let index = this.busData.itemList.findIndex(item => item.nanoid === nanoid);
      this.busData.itemList.splice(index, 1);
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 240px;
}

.product-head {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  margin-top: 15px;
}

.product-head span {
  margin-left: 50px;
}

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  color: goldenrod;
  text-align: center;
  font-size: 14px;
}

.w-percent-90 {
  width: 90%;
}

.w100 {
  width: 120px;
}

.w95 {
  width: 95px;
}

.tax-amount {
  color: red;
  font-size: 18px;
}

.tax-amount span {
  margin-left: 15px;
}

.quote-remark {
  width: 100%;
  padding-right: 15px;
}

.close {
  position: absolute;
  top: 5px;
  right: 18px;
  font-size: 18px;
  cursor: pointer;
}
</style>